import { render, staticRenderFns } from "./proEdit.vue?vue&type=template&id=1ef6bfa5&"
import script from "./proEdit.vue?vue&type=script&lang=js&"
export * from "./proEdit.vue?vue&type=script&lang=js&"
import style0 from "./proEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports